import { create } from 'zustand';

const initialUserState = {
  id: null,
  name: "",
  address: "",
  region: null,
  phone: "",
  regional_id: "",
  notes: "",
  email: "",
  thumb_url: null,
  photo_url: null,
};

const useUserStore = create((set) => ({
  // Estado inicial
  user: { ...initialUserState },

  // Acciones
  setUser: (user) => set({ user }),

  // Acciones específicas
  updateUser: (updates) => set((state) => ({
    user: { ...state.user, ...updates }
  })),

  // Resetear user
  resetUser: () => set({ user: { ...initialUserState } })
}));

export default useUserStore;

